import React from 'react';
export var EloCardArt = _ref => {
  var {
    title
  } = _ref;
  return React.createElement("svg", {
    "aria-labelledby": "elo-card-art-title",
    "data-testid": "elo-card-art",
    height: "24",
    role: "img",
    viewBox: "0 0 38 24",
    width: "38",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: "elo-card-art-title"
  }, title), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M0 0h38v24H0z",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M19.194 3a9.18 9.18 0 110 18.359 9.18 9.18 0 010-18.359",
    fill: "#0F0F12",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M19.194 3a9.18 9.18 0 110 18.359 9.18 9.18 0 010-18.359h0z",
    stroke: "#1B1A19",
    strokeWidth: "0.567"
  }), React.createElement("path", {
    d: "M15.25 9.72c1.33 0 2.444.92 2.743 2.158l-1.137.497v-.003l-1.164.511-2.79 1.22A2.82 2.82 0 0115.25 9.72zm0 1.206a1.614 1.614 0 00-1.607 1.762l2.818-1.215a1.61 1.61 0 00-1.21-.547zm1.971 3.632c-1.01.959-2.346 1.053-3.52.34l.663-1.009c.669.4 1.34.335 2.014-.194l.843.863m1.149-.698l-.007-5.335h1.01v5.19c0 .05.007.094.072.12l.88.342-.397 1.03-1.03-.436c-.39-.165-.527-.405-.528-.911",
    fill: "#FFFFFE",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M22.175 13.77a1.607 1.607 0 01-.12-2.439l-.653-1.057a2.835 2.835 0 00.157 4.567l.616-1.07",
    fill: "#2191C3",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M22.618 10.984a1.61 1.61 0 012.051.948l1.251-.105a2.839 2.839 0 00-3.824-1.958l.522 1.115",
    fill: "#FAEC32",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M24.77 12.577a1.61 1.61 0 01-2 1.483l-.49 1.136a2.837 2.837 0 003.718-2.58l-1.227-.04",
    fill: "#D0362B",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M35 0c1.6 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3H3c-1.6 0-3-1.3-3-3V3c0-1.7 1.3-3 3-3zm0 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h32c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z",
    fill: "#EDEDED",
    fillRule: "nonzero"
  })));
};
EloCardArt.defaultProps = {
  title: 'Elo'
};